const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="max-w-md p-6 mx-auto text-center">
        <h1 className="mb-4 text-2xl font-bold text-text">Something went wrong</h1>
        <p className="mb-6 text-text-secondary">{error?.message}</p>
        <button
          onClick={resetErrorBoundary}
          className="px-4 py-2 text-white rounded bg-primary hover:bg-primary-dark"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
